import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plant",
  "use": "icon-plant-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plant\"><g><path d=\"m113.707 512-58.132-120.208c-43.694-90.351-18.098-196.268 55.842-257.579 46.027-38.166 89.94-78.812 130.239-122.984l10.244-11.229 23.821 31.473c29.393 38.834 51.822 80.128 65.073 121.97z\" fill=\"#00aa95\" /><path d=\"m468.766 149.938-7.743-38.704c-38.269 90.207-136.426 138.139-192.689 200.383-98.392 108.852-154.627 200.383-154.627 200.383h58.256c258.928 0 334.274-174.759 296.803-362.062z\" fill=\"#00cc76\" /><path d=\"m461.022 111.234-14.112 5.649c-34.771 13.919-70.217 25.975-106.117 36.56v.001c-21.412 6.314-42.985 12.104-64.674 17.454-93.258 23.005-162.413 107.214-162.413 207.575v133.527c.001 0 242.122-152.806 347.316-400.766z\" fill=\"#a5e887\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plant.svg
// module id = 3X3C
// module chunks = 102